export class EstadoPedido {

  static Abierto;
  static Cerrado;
  static Aprobado;
  static Rechazado;
  static EnCurso;
  static Finalizado;
  static Procesando;
  static Pagado;
  static Preparando;
  static Error;
  static PendientePago;
  static PendienteCurvas;
  static Facturado;
  static Adicional;
  static PendientePagoAdicionales;


  constructor() {
    EstadoPedido.Abierto = 1;
    EstadoPedido.Cerrado = 2;
    EstadoPedido.Aprobado = 3;
    EstadoPedido.Rechazado = 4;
    EstadoPedido.EnCurso = 5;
    EstadoPedido.Finalizado = 6;
    EstadoPedido.Procesando = 7;
    EstadoPedido.Pagado = 8;
    EstadoPedido.Preparando = 9;
    EstadoPedido.Error = 10;
    EstadoPedido.PendientePago = 11;
    EstadoPedido.PendienteCurvas = 12;
    EstadoPedido.Facturado = 13;
    EstadoPedido.Adicional = 14;
    EstadoPedido.PendientePagoAdicionales = 15;
  }

  get staticAbierto(){
    return EstadoPedido.Abierto;
  }
  get staticCerrado(){
    return EstadoPedido.Cerrado;
  }
  get staticAprobado(){
    return EstadoPedido.Aprobado;
  }
  get staticRechazado(){
    return EstadoPedido.Rechazado;
  }
  get staticEnCurso(){
    return EstadoPedido.EnCurso;
  }
  get staticFinalizado(){
    return EstadoPedido.Finalizado;
  }
  get staticProcesando(){
    return EstadoPedido.Procesando;
  }
  get staticPagado(){
    return EstadoPedido.Pagado;
  }
  get staticPreparando(){
    return EstadoPedido.Preparando;
  }
  get staticError(){
    return EstadoPedido.Error;
  }
  get staticPendientePago(){
    return EstadoPedido.PendientePago;
  }
  get staticPendienteCurvas(){
    return EstadoPedido.PendienteCurvas;
  }
  get staticFacturado(){
    return EstadoPedido.Facturado;
  }
  get staticAdicional(){
    return EstadoPedido.Adicional;
  }
  get staticPendientePagoAdicionales(){
    return EstadoPedido.PendientePagoAdicionales;
  }
}



// WEBPACK FOOTER //
// ./src/app/pedido/estado-pedido.model.ts